import { ColumnClassProperties } from '../common-models/class.model';
import { Currencies } from '../currency-column/currencies-enum';
import { CurrencyPosition } from '../currency-column/currency-position-enum';
import { SeverityEnum } from '../label-column/severity-enum';

//Πρέπει να δημιουργηθεί το IColumn Interface το οποίο θα περιέχει τουλάχιστον τις παρακάτω functions
export interface IColumn<T> {
  GetName(Object?: string): string;
  GetPropertyName(Object?: string): string;
  GetColumnClassProperties?(
    Object?: ColumnClassProperties
  ): ColumnClassProperties;
  GetSort(Object?: any): boolean;
  GetTooltip?(Object?: any): string | ((item?: any) => string);

  GetColumnType(): string; //GetColumnType(): ColumnTypeEnum
  GetValue(Object?: any): string | ((item?: any) => string); //GetValue() : String ( Θα πρέπει να επιστρέφει την τιμή όπως θα εμφανίζεται στο table μετά από απαραίτητους μετασχηματισμούς )
  GetSeverity?(Object?: T): SeverityEnum;
  GetAction?(Object?: T, event?: any): any | undefined;
  // For now only the Button Column implements these two methods
  GetIsDisabled?(Object?: T): boolean;
  GetIsVisible?(Object?: T): boolean;

  frozen?: boolean;
  alignFrozen?: 'left' | 'right';
}

//Πρέπει να δημιουργηθεί abstract κλάση η οποία θα λειτουργεί ως βάση για όλα τα Column Components και θα πρέπει να περιέχει τουλάχιστον τα παρακάτω properties.
export class Column<T> {
  //Id: String (auto generated guid)
  Name: string = ''; //Name: String (χρησιμοποιείται ως header στο Column)
  PropertyName!: string; //PropertyName: String ( το όνομα του property από το οποίο πρέπει να ληφθεί η τιμή , πρέπει να υποστηρίζονται και nested objects με δομή “request.auditor.name“)
  ColumnClassProperties?: ColumnClassProperties; //Classes: Set<String> (Λίστα με css classes για μορφοποιήση)
  MaxLength?: number = 0; //MaxLength : number (σε περίπτωση που είναι μεγαλύτερο από 0 θα πρέπει να εφαρμόζεται ellipsis css και να υπάρχει tooltip on hover.)
  Sort?: boolean;
  Tooltip!: string | ((item?: any) => string);
  Action?: (item?: T, event?: any) => any;

  frozen = false;
  alignFrozen: 'left' | 'right' = 'left';
}

export interface ColumnConfig<T> {
  name?: string;
  propertyName?: string;
  sort?: boolean;
  tooltip?: string | ((item?: any) => string);
  action?: (item?: T, event?: any) => any;

  currencySymbol?: Currencies;
  currencyPosition?: CurrencyPosition;
  decimalSeperator?: string;
  thousandsSeperator?: string;

  convertToLocalTimeZone?: boolean;
  parseFormat?: string;
  format?: string;

  cases?: { [key: symbol]: () => T };

  classProperties?: ColumnClassProperties;
  isVisibleAction?: (item?: T) => boolean;
  isDisabledAction?: (item?: T) => boolean;

  frozen?: boolean;
  alignFrozen?: 'left' | 'right';
}
